import { useLocalization } from "@fluent/react";
import { TextField } from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";

interface EmailTextFieldProps {
    value: string;
    required?: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    showError?: boolean
}

export const EmailTextField: React.FC<EmailTextFieldProps> = ({ value, required = true, onChange, showError }) => {
    const { l10n } = useLocalization();
    const [emailError, setEmailError] = useState("");

    useEffect(() => {
        if (showError && value === "") {
            setEmailError(l10n.getString("email-is-required", null, "_E-mail jest wymagany"))
        }
    }, [showError])

    const validateEmail = () => {
        if(required && value === "") {
            setEmailError(l10n.getString("email-is-required", null, "_E-mail jest wymagany"))
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (value !== "" && !emailRegex.test(value)) {
            setEmailError(l10n.getString("email-incorrect", null, "_Nieprawidłowy adres e-mail"));
        } else {
            setEmailError("");
        }
    };

    return (
        <TextField
            label="Email"
            value={value}
            required={required}
            onChange={onChange}
            onBlur={validateEmail}
            error={!!emailError}
            helperText={emailError}
        />
    );
};
